"use strict";

exports.__esModule = true;
exports.getGridCellDimensions = getGridCellDimensions;
exports.getGridCellPosition = getGridCellPosition;
exports.getGridColumnIndexAt = getGridColumnIndexAt;
exports.getGridColumnWidth = getGridColumnWidth;
exports.getGridRowHeight = getGridRowHeight;
exports.getGridRowIndexAt = getGridRowIndexAt;
/**
 * Get the row height for the given grid configuration.
 */
function getGridRowHeight(config) {
  var height = config.height,
    rowCount = config.rowCount,
    padding = config.padding;
  var availableHeight = padding != null ? height - padding * 2 : height;
  return availableHeight / rowCount;
}

/**
 * Get the column width for the given grid configuration.
 */
function getGridColumnWidth(config) {
  var width = config.width,
    columnCount = config.columnCount,
    padding = config.padding;
  var availableWidth = padding != null ? width - padding * 2 : width;
  return availableWidth / columnCount;
}

/**
 * Get the index of the row at the given offset in pixels.
 */
function getGridRowIndexAt(config, offset) {
  var padding = config.padding;
  var normalizedOffset = Math.max(0, padding != null ? offset - padding : offset);
  return Math.ceil(normalizedOffset / getGridRowHeight(config));
}

/**
 * Get the index of the column at the given offset in pixels.
 */
function getGridColumnIndexAt(config, offset) {
  var padding = config.padding;
  var normalizedOffset = Math.max(0, padding != null ? offset - padding : offset);
  return Math.ceil(normalizedOffset / getGridColumnWidth(config));
}

/**
 * Get the appropriate grid row / column start and end values for a
 * particular element.
 */
function getGridCellPosition(config, _ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height;
  var rowCount = config.rowCount,
    columnCount = config.columnCount;
  var gridRowStart = Math.max(1, Math.min(rowCount, getGridRowIndexAt(config, Math.max(0, y) + 1)));
  var gridRowEnd = Math.max(1, Math.min(rowCount + 1, getGridRowIndexAt(config, Math.max(0, y + height) + 1)));
  var gridColumnStart = Math.max(1, Math.min(columnCount, getGridColumnIndexAt(config, Math.max(0, x) + 1)));
  var gridColumnEnd = Math.max(1, Math.min(columnCount + 1, getGridColumnIndexAt(config, Math.max(0, x + width) + 1)));
  return {
    gridRowStart: gridRowStart,
    gridRowEnd: gridRowEnd,
    gridColumnStart: gridColumnStart,
    gridColumnEnd: gridColumnEnd
  };
}

/**
 * Get the dimensions for a cell based on grid row / column start and ends.
 */
function getGridCellDimensions(config, _ref2) {
  var gridRowStart = _ref2.gridRowStart,
    gridRowEnd = _ref2.gridRowEnd,
    gridColumnStart = _ref2.gridColumnStart,
    gridColumnEnd = _ref2.gridColumnEnd;
  var padding = config.padding != null ? config.padding : 0;
  var rowHeight = getGridRowHeight(config);
  var columnWidth = getGridColumnWidth(config);
  var spanRows = gridRowEnd - gridRowStart;
  var spanColumns = gridColumnEnd - gridColumnStart;
  var x = padding + (gridColumnStart - 1) * columnWidth;
  var y = padding + (gridRowStart - 1) * rowHeight;
  var width = columnWidth * spanColumns;
  var height = rowHeight * spanRows;
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}